// import MadfuWidgetAr from '@/components/icons/madfu/MadfuWidgetAr';
// import MadfuWidgetCheckedAr from '@/components/icons/madfu/MadfuWidgetCheckedAr';
// import MadfuWidgetCheckedEn from '@/components/icons/madfu/MadfuWidgetCheckedEn';
// import MadfuWidgetEn from '@/components/icons/madfu/MadfuWidgetEn';
import { useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import MadfuWidgetModal from './MadfuWidgetModal';
import Image from '@/components/global/image';
import useOnClickOutsideV2 from '@/hooks/global/useOnClickOutsideV2';
import UseLocale from '@/hooks/useLocale';
const MadfuWidget = () => {
  const { locale } = UseLocale();
  const [show, setShow] = useState(false);
  const refModel = useRef();
  const refBtn = useRef();

  useOnClickOutsideV2([refModel, refBtn], () => setShow(false));
  const { t } = useTranslation('common');

  return (
    <>
      {/* <div className='flex gap-2 rounded-md sm:items-center sm:justify-center'>
      {locale === 'en' ? 
        show===true ? <MadfuWidgetCheckedEn setShow={setShow} /> : <MadfuWidgetEn {...{ setShow, show }} /> 
       : 
        show===true ? <MadfuWidgetCheckedAr setShow={setShow} /> : <MadfuWidgetAr {...{ setShow, show }} />
      }
    </div> */}

      <div className='mt-2 flex items-center justify-center rounded-md bg-white max-[470px]:items-start max-[470px]:justify-start'>
        {/* {locale === "en" ? (
        show === true ? (
          <MadfuWidgetCheckedEn setShow={setShow} />
        ) : (
          <MadfuWidgetEn {...{ setShow, show }} />
        )
      ) : show === true ? (
        <MadfuWidgetCheckedAr setShow={setShow} />
      ) : (
        <MadfuWidgetAr {...{ setShow, show }} />
      )} */}

        {/* {locale === "en" ? (
        <p className="w-full text-lg bg-gray-500">
          
          <ImgTag
                    src={`/imgs/madfu/new/{madfu-logo-${locale}}.png`}
                    alt="madfu logo"
                    className="object-contain h-20"
                  />
          <span>{t("Split up to 6 Payments")}</span>
        </p>
      ) : (
        <p className="w-full text-lg bg-gray-500">
          <span className="font-bold">{t("Split into Payments")}</span>{" "}
          <span>{t("Split up to 6 Payments")}</span>
        </p>
      )} */}
        <p
          ref={refBtn}
          className='text-md flex w-full cursor-pointer gap-4 rounded-md border p-3 pl-3 pr-2'
          onClick={() => setShow((show) => !show)}
        >
          <Image
            loading='eager'
            priority='high'
            src={`/imgs/madfu/new/madfu-logo-${locale}.png`}
            alt='madfu logo'
            width={100}
            height={28}
            className='w-16 object-contain'
          />
          <span className='text-xs leading-5 sm:text-[15px]'>
            {t(
              'Split your order up to 4 Payments - interest free, Sharia law Complient'
            )}
          </span>
        </p>
        <div ref={refModel}>
          <MadfuWidgetModal {...{ t, locale, show, setShow }} />
        </div>
      </div>
    </>
  );
};

export default MadfuWidget;
